export default class ApiSettings {
    public url: string;
    public baseUrl: string;
    constructor(settings: any) {
        this.url = settings.url;
        this.baseUrl = settings.baseUrl;
    }
}